import template from './filter.html';

const component = {
	template,
	controllerAs: 'filter',
	bindToController:true,
	bindings:{
		overwrite:'='
	},
	controller: function (
		$ionicHistory,
		$ionicLoading,
		$ionicScrollDelegate,
		$q,
		$rootScope,
		$scope, 
		$state,
		$stateParams, 
		_,
		Attribute,
		Brand,
		Category,
		Definition,
		Filter,
		Price,
		Search,
		Session,
	) {
		"ngInject";
		
		var vm = this;
		var reload = false;
		var process = $state.is('tab.process') || $state.is('tab.ranking');

		vm.status = {
			loading: false,
			panel: null,
			show: false,
			animate: false
		};

		function initialize() {

			if (!vm.categories) {
				Category.complete().then(res => {
					vm.category_groups = res.groups; 
					vm.categories = res.categories;
					setActives();
				})
			} else {
				setActives();
			}
		}

		function setActives() {
			vm.actives = Filter.actives();

			if (vm.actives.webshop === undefined) {
				//vm.actives.webshop = true;
			}

			vm.data.brands.forEach((brand) => {
				brand.on = vm.actives.brands && vm.actives.brands.indexOf(brand.id) > -1;
			});

			vm.categories.forEach((category) => {
				category.on = vm.actives.categories && vm.actives.categories.indexOf(category.id) > -1;
			});

			vm.data.price.forEach((price) => {
				price.on = vm.actives.price && vm.actives.price.filter(function(activePrice) {
					return price.range.join('-') === activePrice;
				}).length > 0;
			});

			if (vm.data.definitions) {
				vm.data.definitions.forEach((definition) => {
					definition.on = vm.actives.definitions && vm.actives.definitions.indexOf(definition.id) > -1;
				});
			}

			// make sure stuff that isnt in the filters is not in the actives
			vm.actives.brands = vm.data.brands.filter((brand) => brand.on).map((brand) => brand.id);
			vm.actives.price = vm.data.price.filter((price) => price.on).map((price) => price.range.join('-'));
			if (vm.actives.brands.length === 0) delete vm.actives.brands;
			if (vm.actives.price.length === 0) delete vm.actives.price;

			Filter.setAllActives(vm.actives);

			if (vm.data.attributes) {

				vm.data.attributes.forEach((attribute) => {
					if (attribute.range) {
						attribute.options.forEach((option) => {
							option.on = vm.actives.filters && vm.actives.filters[attribute.id] && vm.actives.filters[attribute.id].filter(function(range) {
								return option.range.join('-') === range;
							}).length > 0;
						});
					} else {
						attribute.options.forEach((option) => {
							option.on = vm.actives.filters && vm.actives.filters[attribute.id] && vm.actives.filters[attribute.id].indexOf(option.id) > -1;
						});
					}
				});
			}

			filterHandler();
		}

		function filterHandler() {

			var uids;
			var promises = {};
			var pills = {
				categories: [],
				brands: [],
				prices: []
			};
			var interfaces = function(options) {

				Price.interface(vm.data.price, _.filter(options, (option, index) => index !== 'price'), vm.data.all, process, vm.actives.categories);
				Brand.interface(vm.data.brands, _.filter(options, (option, index) => index !== 'brands'), vm.data.all, process, vm.actives.categories);

				if (vm.data.attributes) {
					Attribute.interface(vm.data.attributes, _.filter(options, (option, index) => index !== 'filters'), vm.data.all, process);
				}

				if (!_.isEmpty(options)) {
					uids = _.values(options).reduce(function(a, b) {
						return _.intersection(a, b);
					}, vm.data.all);

					Filter.products(uids);
				} else {
					if (vm.actives.webshop) {
						uids = vm.data.all
					} else {
						uids = _.difference(vm.data.all, vm.data.webshop)
					}

					Filter.products(uids, vm.actives.categories === undefined);
				}

				// PILLS 
				if (vm.actives.categories) pills.categories = vm.categories.filter((category) => category.on).map((category) => {
					return { id: category.id, name: category.lang[$rootScope.language].plural };
				});
				if (vm.actives.brands) pills.brands = vm.data.brands.filter((brand) => brand.on).map((brand) => {
					return  { id: brand.id, name: brand.name };
				});
				if (vm.actives.price) pills.prices = vm.data.price.filter((price) => price.on).map((price) => {
					return { range:price.range } 
				});

				if (vm.actives.filters) pills.filters = vm.data.attributes.filter(attribute => attribute.id in vm.actives.filters);
				if (vm.actives.skey) pills.skey = vm.actives.skey;

				Filter.pills(pills);
			}

			// OPTIONS
			if (vm.actives.definitions) promises.definitions = Definition.options(vm.data.definitions, vm.data.all);
			if (vm.actives.price) promises.price = Price.options(vm.data.price);
			if (vm.actives.brands) promises.brands = Brand.options(vm.data.brands);
			if (vm.actives.skey) promises.skey = Search.id(vm.actives.skey);
			if (vm.actives.filters && vm.actives.categories) promises.filters = Attribute.options(vm.data.attributes);
			if (vm.actives.promo) promises.promo = $q.resolve(vm.data.promo);
			if (vm.actives.deadstock) promises.deadstock = $q.resolve(vm.data.deadstock);
			if (vm.actives.margin) promises.margin = $q.resolve(vm.data.margin);
			if (!vm.actives.webshop) promises.webshop = $q.resolve(_.difference(vm.data.all, vm.data.webshop));			
			

			if (!_.isEmpty(promises)) {
				$q.all(promises).then(function(options) {
					interfaces(options);
				}).catch(err => {
					console.log(err);
					$ionicLoading.hide(); // doesnt need a finally since the success will end the loader eventually
				})
			} else {
				interfaces([]);
			}
		}

		vm.toggle = {
			sidebar: function() {
				vm.status.panel = null;
				Filter.openFilters();

				// reload if category has changed
				if (reload) {
					reload = false;
					Filter.reload();
				}
			},
			panel: function(attribute) {
				if(!vm.status.loading) {
					vm.status.panel = attribute;
					
					// reload if category has changed
					if (reload) {
						reload = false;
						Filter.reload();
					}
					
				}
			},
			price: function(price) {
				Filter.toggle.price(price);

				if (price.on) {
					Filter.log({
						type: 'price',
						value: price.range.join('-')
					});
				}
				
				Filter.change();
			},
			brand: function(brand) {
				Filter.toggle.brand(brand);
				if (brand.on) {
					Filter.log({
						type: 'brand',
						value: brand.id
					});
				}
				Filter.change();
			},
			filter: function(id, option) {
				Filter.toggle.filter(id, option);

				if (option.on) {
					Filter.log({
						type: 'attribute',
						attribute_id: id,
						needle_id: option.id,
						value: option.value
					});
				}
				
				Filter.change();
			},
			range: function(id, option) {
				Filter.toggle.range(id, option);

				if (option.on) {
					Filter.log({
						type: 'range',
						attribute_id: id,
						value: option.range.join('-')
					});
				}
				
				Filter.change();
			},
			webshop: function() {
				Filter.toggle.webshop(vm.actives.webshop);
				Filter.change();
			},
			promo: function() {
				Filter.toggle.promo(vm.actives.promo);
				Filter.change();
			},
			margin: function() {
				Filter.toggle.margin(vm.actives.margin);
				Filter.change();
			},
			deadstock: function() {
				Filter.toggle.deadstock(vm.actives.deadstock);
				Filter.change();
			},
			category: function(category) {
				Filter.toggle.category(category);
				reload = true;
			},
			categoryGroup: function(group) {
				group.active = !group.active;
				$ionicScrollDelegate.resize();
			}
		};

		vm.clear = {
			price: function() {
				Filter.setActive('price');
				initialize();
			},
			categories: function() {
				Filter.setActive('categories');
				initialize();
			},
			brands:function() {
				Filter.setActive('brands');
				initialize();
			},
			filter: function(attributeId) {
				Filter.clearFilter(attributeId);
				initialize();
			},
			promo: function() {
				Filter.setActive('promo');
				Filter.setActive('margin');
				Filter.setActive('deadstock');
				initialize();
			}
		}

		vm.groupSelected = (groupId) => {
			return vm.categories.filter((category) => category.group_id === groupId && category.on).length > 0;
		}

		$scope.$on('filters:changed', function(e, init) {
			
			vm.actives = Filter.actives();

			if (init) {
				initialize();
			} else {
				filterHandler();
			}
		});

		$scope.$on('filters:interface', function(e, filters) {
			vm.data = filters;
			initialize();
		});

		$scope.$on('filters:show', function(e, d) {
			vm.status.panel = null;
			vm.status.show = d;
		});

		$scope.$on('filters:animate', function(e, d) {
			vm.status.animate = d;
		});
	}
};

export default component;


// WEBPACK FOOTER //
// ./app/components/filter/filter.component.js